import { mergeProps } from "react-aria"
import styled from "@emotion/styled"

import { useEnv } from "contexts/Env"
import { useConsole } from "contexts/Console"
import { useLocale } from "contexts/Locale"
import { useUser } from "contexts/User"

import { headline100, surtitle70 } from "css/text"

import Link from "components/link/Link"
import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import { getPriceDatas } from "components/price/utils"

const Root = styled.section`
  align-content: center;
  background: white;
  display: grid;
  grid-template-rows: repeat(2, min-content);
  justify-content: center;
  row-gap: 1.25rem;

  hgroup,
  > div {
    text-align: center;
    transition: opacity 0.15s;

    .show & {
      opacity: 1;
      transition-delay: 0.3s;
    }

    .hide & {
      opacity: 0;
    }
  }

  h2 {
    ${headline100}
    display: inline;
    grid-row-start: 2;
  }

  p {
    ${surtitle70}
    grid-row-start: 1;
    margin-block-end: 10px;
  }
`

export default function DownloadBrochure(props) {
  const {
    model: { name: modelName, ...model },
    title,
    link,
  } = props
  const console = useConsole()
  const env = useEnv()
  const locale = useLocale()
  const { countryCode } = useUser()

  const pathToBrochure = new URL(`/api/brochure/${locale?.current?.codes?.www}/${model.familyNode.code}/${model.rmc}.pdf`, env.assets).href

  const fileName = `/watches/${model.familyNode.code}/${model.rmc}.pdf`

  const linkProps = mergeProps(link, {
    icon: "download",
    external: pathToBrochure,
    style: "text green",
  })

  const triggerWaEvent = async () => {
    const { model } = props

    const { price, currency } = await getPriceDatas({ rmc: model.rmc, countryCode, locale, env })

    waTriggerEvent({
      eventName: "download",
      eventType: "Click",
      products: [
        {
          productCategory: model.familyNode?.code,
          productModel: model.nameCode,
          productID: model.rmc,
          productQuantity: "1",
          productPrice: price,
          currency: currency,
        },
      ],
      downloadInfo: {
        fileName,
        type: "brochure",
        position: "model page",
        size: "",
      },
    })
  }

  console.verbose("Model:ModelDownloads:DownloadBrochure(%o)", props)
  return (
    <Root>
      <hgroup>
        <p>{modelName}</p>
        <h2>{title}</h2>
      </hgroup>
      <div>
        {link?.label && (
          <Link {...linkProps} onClick={triggerWaEvent}>
            {link?.label}
          </Link>
        )}
      </div>
    </Root>
  )
}
